import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { flexRender, type Table } from '@tanstack/react-table';

import { TableRowType } from '../_hooks/useDcr';

import { dcrTableHeaderStyles as sx } from './DCRTableHeader.styles';

export const DCRTableHeader = ({
	table,
	label
}: {
	table: Table<TableRowType>;
	label: string;
}) => (
	<TableRow sx={sx.header}>
		{table.getHeaderGroups()[0].headers.map(header => (
			<TableCell
				key={header.id}
				sx={{
					width: header.getSize()
				}}
			>
				{header.id === 'field'
					? label
					: flexRender(header.column.columnDef.header, header.getContext())}
			</TableCell>
		))}
	</TableRow>
);
